export enum DriveTypeEnum {
    SCREEN_DRIVE = "screen-drive",
    USER_DRIVE = "user-drive",
}
